import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=2592619a"
import script from "./Frame.vue?vue&type=script&lang=ts"
export * from "./Frame.vue?vue&type=script&lang=ts"
import style0 from "./Frame.vue?vue&type=style&index=0&id=2592619a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports